import Box, { type BoxProps } from '@mui/material/Box';
import { type SxProps, type Theme } from '@mui/material/styles';
import useTheme from '@mui/material/styles/useTheme';
import React, { type MouseEventHandler } from 'react';
import Spritesheet from 'react-responsive-spritesheet';
import { checkUndefinedOrNull } from '../_tools/Tools';

export type ImageProps = {
    align?: 'left' | 'center' | 'right' | 'justify';
    cover?: boolean;
    config?: any;
    height: number;
    disablePlaceholder?: boolean;
    onClick?: MouseEventHandler;
    onMouseDown?: MouseEventHandler;
    onMouseUp?: MouseEventHandler;
    src: string;
    step: number;
    sx?: SxProps<Theme>;
    width: number;
} & BoxProps;

function Image360aElement(props: ImageProps) {
    const { align = 'left', cover, height = 480, disablePlaceholder, onClick, onMouseDown, onMouseUp, src, step = 24, sx, width = 640 } = props;
    const theme = useTheme();

    function getMouseXY(mouseEvent, spritesheet) {
        const obj = document.querySelector('.react-responsive-spritesheet');
        const objRect = obj.getBoundingClientRect();
        const objWidth = objRect.width;

        let xposRelative = 0;
        if (mouseEvent) xposRelative = mouseEvent.clientX - objRect.left;

        const frames = spritesheet.getInfo('steps');
        let newIndex = Math.ceil(frames * (xposRelative / objWidth));
        if (newIndex < 0) newIndex = 0;
        else if (newIndex > frames - 1) newIndex = frames - 1;
        spritesheet.goToAndPause(newIndex);
    }

    return (
        <Box
            onClick={onClick}
            onMouseDown={onMouseDown}
            onMouseUp={onMouseUp}
            component="span"
            sx={{
                'width': 1,
                'lineHeight': 0,
                'display': 'block',
                'overflow': 'hidden',
                'position': 'relative',
                'background': disablePlaceholder ? 'transparent' : theme.palette.background.default,
                'pt': 'calc(100% / ' + width + ' * ' + height + ')',
                '& .wrapper': {
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    lineHeight: 0,
                    position: 'absolute',
                    backgroundSize: 'cover !important',
                },
                '& .wrapper.lazy-load-image-background.blur.lazy-load-image-loaded.down': {
                    paddingTop: 0, // Bilder haben sich bei Müller(54100) verschoben
                },
                'cursor': !checkUndefinedOrNull(onClick) || (!checkUndefinedOrNull(onMouseDown) && !checkUndefinedOrNull(onMouseUp)) ? 'pointer' : undefined,
                ...sx,
            }}
        >
            <Box
                component={Spritesheet}
                autoplay
                className="wrapper"
                timeout={500}
                loop
                image={src}
                widthFrame={width}
                heightFrame={height}
                steps={step}
                fps={2}
                onMouseDown={(spritesheet) => {
                    spritesheet.pause();
                    const e: HTMLElement = document.querySelector('.react-responsive-spritesheet');

                    e.onmousemove = (f) => getMouseXY(f, spritesheet);
                }}
                onMouseUp={(spritesheet) => {
                    spritesheet.play();
                    const e: HTMLElement = document.querySelector('.react-responsive-spritesheet');

                    e.onmousemove = undefined;
                }}
                onMouseLeave={(spritesheet) => {
                    spritesheet.play();
                    const e: HTMLElement = document.querySelector('.react-responsive-spritesheet');

                    e.onmousemove = undefined;
                }}
                sx={{
                    background: 'transparent',
                    width: cover && height ? 'calc(100% / (100% / ' + width + ' * ' + height + ') / ' + height + ')' : '100% !important',
                    height: height || '100% !important',
                    objectFit: cover ? 'cover' : 'contain',
                    objectPosition: !cover ? (align === 'justify' ? 'center' : align) : undefined,
                    verticalAlign: 'center',
                }}
            />
        </Box>
    );
}

export default React.memo(Image360aElement);
